import { render, staticRenderFns } from "./panel-navigation.vue?vue&type=template&id=a152a6d4&scoped=true&"
import script from "./panel-navigation.vue?vue&type=script&lang=js&"
export * from "./panel-navigation.vue?vue&type=script&lang=js&"
import style0 from "./panel-navigation.vue?vue&type=style&index=0&id=a152a6d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a152a6d4",
  null
  
)

export default component.exports